export const InawoPassSuccessIcon = () => {
  return (
    <svg
      width="17"
      height="17"
      viewBox="0 0 17 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="8.50006" cy="8.59528" r="8.37848" fill="#22A24E" />
      <mask
        id="mask0_2014_22374"
        style={{ maskType: "alpha" }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="17"
        height="17"
      >
        <circle cx="8.50006" cy="8.59528" r="8.37848" fill="white" />
      </mask>
      <g mask="url(#mask0_2014_22374)">
        <path
          d="M4.47852 6.94867L8.55847 11.6115L17.0098 4.90869"
          stroke="white"
          strokeWidth="2.23426"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
    </svg>
  );
};
